import { Breadcrumb } from './breadcrumbs';

export interface FieldSetReview {
  reviewed: boolean;
  fieldSetReviews: Record<string, Record<number, FieldSetReview>>;
}

const defaultFieldSetReview: FieldSetReview = {
  reviewed: false,
  fieldSetReviews: {},
};

export function getFieldSetReview(
  fieldSetReviews: Record<string, Record<number, FieldSetReview>>,
  breadcrumb: Breadcrumb,
): FieldSetReview {
  const itemReviews = fieldSetReviews[breadcrumb.id] || {};
  const nestedReview = itemReviews[breadcrumb.index] || defaultFieldSetReview;
  return nestedReview;
}

export function getUpdateNextReviews(
  fieldSetReviews: Record<string, Record<number, FieldSetReview>>,
  breadcrumbs: Breadcrumb[],
  reviewed: boolean,
): Record<string, Record<number, FieldSetReview>> {
  if (breadcrumbs.length === 0) {
    return fieldSetReviews;
  }
  const breadcrumb = breadcrumbs[0];
  const itemReviews = fieldSetReviews[breadcrumb.id] || {};
  const nestedReview = itemReviews[breadcrumb.index] || defaultFieldSetReview;
  const isTarget = breadcrumbs.length === 1;
  const isReviewed = reviewed && (isTarget || nestedReview.reviewed);
  return {
    ...fieldSetReviews,
    [breadcrumb.id]: {
      ...itemReviews,
      [breadcrumb.index]: {
        reviewed: isReviewed,
        fieldSetReviews: getUpdateNextReviews(
          nestedReview.fieldSetReviews,
          breadcrumbs.slice(1),
          reviewed,
        ),
      },
    },
  };
}
